import axios from "axios";
import { Lead_Service_URL, Partner_Service_URL } from "../Url";

export const searchLeadActions = {
  SEARCH_LEAD_SUCCESS: "SEARCH_LEAD_SUCCESS",
  SEARCH_LEAD_ERROR: "SEARCH_LEAD_ERROR",
};

export function searchLeadDetails(props) {
  const { access_token, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/partnerGlobalSearch`,
      data: values
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(searchLeadSuccess(response.data));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(searchLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(searchLeadError(err));
          return err.response;
        }
      });
}

export function searchLeadError(error) {
  return {
    type: searchLeadActions.SEARCH_LEAD_ERROR,
    payload: error,
  };
}

export function searchLeadSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: searchLeadActions.SEARCH_LEAD_SUCCESS,
      payload: props,
    });
  };
}


export const searchPartnerActions = {
  SEARCH_PARTNER_SUCCESS: "SEARCH_PARTNER_SUCCESS",
  SEARCH_PARTNER_ERROR: "SEARCH_PARTNER_ERROR",
};

export function searchPartnerDetails(props) {
  const { access_token, values } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/globalSearch/PartnerFirmDetails`,
      data: values
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(searchPartnerSuccess(response.data));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(searchLeadError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(searchLeadError(err));
          return err.response;
        }
      });
}

export function searchPartnerError(error) {
  return {
    type: searchPartnerActions.SEARCH_PARTNER_ERROR,
    payload: error,
  };
}

export function searchPartnerSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: searchPartnerActions.SEARCH_PARTNER_SUCCESS,
      payload: props,
    });
  };
}





export const DropDownListActions = {
  DROPDOWN_LIST_SUCCESS: "DROPDOWN_LIST_SUCCESS",
  DROPDOWN_LIST_ERROR: "DROPDOWN_LIST_ERROR",
};

export function getDropdownList(props) {
  const { access_token } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Service_URL}/get/partnerGlobalSearchMasterDropdown`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getDropdownListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getDropdownListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getDropdownListError(err));
          return err.response;
        }
      });
}

export function getDropdownListError(error) {
  return {
    type: DropDownListActions.DROPDOWN_LIST_ERROR,
    payload: error,
  };
}

export function getDropdownListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: DropDownListActions.DROPDOWN_LIST_SUCCESS,
      payload: props,
    });
  };
}




export function getDropdownListPartner(props) {
  const { access_token } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/getAll/partnerFirmStatus`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {

          return response;
        } else {
          const error = new Error(response.statusText);

          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {

          return err.response;
        }
      });
}

